import React from "react";
import Typography from "../Typography";
import "./sectionNavigation.css";

/**
 * Reusable section/tab navigation. Renders a horizontal tab list.
 * Styles live in `sectionNavigation.css` (active/hover colors from theme.css).
 *
 * @param {Array}   items         – { id, icon, label }[]
 * @param {string}  activeTab     – id of active item
 * @param {function} onTabChange  – (id) => void
 * @param {string}  [listClassName="section-nav-list"] – class on <ul> for styling
 * @param {number}  [iconSize]    – optional size prop for icon (e.g. 16)
 */
const SectionNavigation = ({
  items = [],
  activeTab,
  onTabChange,
  listClassName = "section-nav-list",
  iconSize,
}) => {
  return (
    <div className="flex flex-wrap -mx-4 mt-0 mb-4">
      <div className="w-full bg-surface-primary border-b border-border-primary p-0">
        <ul className={`${listClassName} flex list-none m-0 p-0 gap-4`}>
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <li
                key={item.id}
                className={`tab-item relative cursor-pointer ${
                  activeTab === item.id ? "active" : ""
                }`}
                onClick={() => onTabChange(item.id)}
              >
                <Typography
                  variant="span1"
                  className="nav-link menu-link flex items-center gap-2 px-2 py-2 text-sm font-medium no-underline whitespace-nowrap"
                >
                  {Icon && (
                    <>
                      <Icon
                        className="text-lg leading-none"
                        {...(typeof iconSize === "number" ? { size: iconSize } : {})}
                      />{" "}
                    </>
                  )}
                  <Typography variant="text2" component="span">
                    {item.label}
                  </Typography>
                </Typography>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SectionNavigation;
